// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__wvWdp","home_title":"preset_apps_home_title__Jy7n0","foot":"preset_apps_foot__55pSV"};